import { useQuery } from '@tanstack/react-query'
import api from '../../api'

const useMongoDBRequests = () =>
	useQuery({
		queryKey: ['mongodb'],
		queryFn: () => api.mongodb.getMongoDBRequests(),
		select: (data) => data.body,
		retry: false
	})

export default useMongoDBRequests
